if (!window.Opensoft){
	Opensoft = {};
}
if (!window.Opensoft.PaginateJQuery){
	Opensoft.PaginateJQuery = {};
}

Opensoft.PaginateJQuery = function() {
	return {
		init: function(){
			
			/* Set the defaults for DataTables initialisation */
			jQuery.extend( true, jQuery.fn.dataTable.defaults, {
				"sDom": "<'row-fluid'<'span6'i><'span6'<'pull-right'f>>r>t<'row-fluid'<'span6'l><'span6'p>>",
				"sPaginationType": "bootstrap",
				"oLanguage": {
					"sLengthMenu": " _MENU_ registos por página",
					"sInfo": "<span class ='table-box-name'>Total: _TOTAL_</span>",
					"sInfoEmpty": "<span class ='table-box-name'>Sem resultados</span>",
					"sInfoFiltered": "<span class ='table-box-name'> de um total de _MAX_ </span>",
					"sEmptyTable":"Sem dados disponíveis.",
					"sZeroRecords": "Sem dados disponíveis.",
					"sSearch": "<span class ='table-box-name'>Filtrar por: _INPUT_</span>"+
                        "<span class='help-block'>(qualquer palavra da lista)</span>",
					"oSearch": "Filtrar",
					"oPaginate": {
						"sPrevious": "Anteriores",
						"sNext": "Próximos"
						
					}
				}
				
			} );
			
			/* Default class modification */
			jQuery.extend( jQuery.fn.dataTableExt.oStdClasses, {
				"sWrapper": "dataTables_wrapper form-inline"
			} );
			
			/* API method to get paging information */
			jQuery.fn.dataTableExt.oApi.fnPagingInfo = function ( oSettings )
			{
				return {
					"iStart":         oSettings._iDisplayStart,
					"iEnd":           oSettings.fnDisplayEnd(),
					"iLength":        oSettings._iDisplayLength,
					"iTotal":         oSettings.fnRecordsTotal(),
					"iFilteredTotal": oSettings.fnRecordsDisplay(),
					"iPage":          Math.ceil( oSettings._iDisplayStart / oSettings._iDisplayLength ),
					"iTotalPages":    Math.ceil( oSettings.fnRecordsDisplay() / oSettings._iDisplayLength )
				};
			};
			
			/* Bootstrap style pagination control */
			jQuery.extend( jQuery.fn.dataTableExt.oPagination, {
				"bootstrap": {
					"fnInit": function( oSettings, nPaging, fnDraw ) {
						var oLang = oSettings.oLanguage.oPaginate;
						var fnClickHandler = function ( e ) {
							e.preventDefault();
							if ( oSettings.oApi._fnPageChange(oSettings, e.data.action) ) {
								fnDraw( oSettings );
							}
						};

						jQuery(nPaging).addClass('pagination').append(
							'<ul>'+
								'<li class="prev disabled"><a href="#">&larr; '+oLang.sPrevious+'</a></li>'+
								'<li class="next disabled"><a href="#">'+oLang.sNext+' &rarr; </a></li>'+
							'</ul>'
						);
						var els = jQuery('a', nPaging);
						jQuery(els[0]).bind( 'click.DT', { action: "previous" }, fnClickHandler );
						jQuery(els[1]).bind( 'click.DT', { action: "next" }, fnClickHandler );
					},

					"fnUpdate": function ( oSettings, fnDraw ) {
						var iListLength = 5;
						var oPaging = oSettings.oInstance.fnPagingInfo();
						var an = oSettings.aanFeatures.p;
						var i, j, sClass, iStart, iEnd, iHalf=Math.floor(iListLength/2);

						if ( oPaging.iTotalPages < iListLength) {
							iStart = 1;
							iEnd = oPaging.iTotalPages;
						}
						else if ( oPaging.iPage <= iHalf ) {
							iStart = 1;
							iEnd = iListLength;
						} else if ( oPaging.iPage >= (oPaging.iTotalPages-iHalf) ) {
							iStart = oPaging.iTotalPages - iListLength + 1;
							iEnd = oPaging.iTotalPages;
						} else {
							iStart = oPaging.iPage - iHalf + 1;
							iEnd = iStart + iListLength - 1;
						}

						for ( i=0, iLen=an.length ; i<iLen ; i++ ) {
							// Remove the middle elements
							jQuery('li:gt(0)', an[i]).filter(':not(:last)').remove();

							// Add the new list items and their event handlers
							for ( j=iStart ; j<=iEnd ; j++ ) {
								sClass = (j==oPaging.iPage+1) ? 'class="active"' : '';
								jQuery('<li '+sClass+'><a href="#">'+j+'</a></li>')
									.insertBefore( jQuery('li:last', an[i])[0] )
									.bind('click', function (e) {
										e.preventDefault();
										oSettings._iDisplayStart = (parseInt(jQuery('a', this).text(),10)-1) * oPaging.iLength;
										fnDraw( oSettings );
									} );
							}

							// Add / remove disabled classes from the static elements
							if ( oPaging.iPage === 0 ) {
								jQuery('li:first', an[i]).addClass('disabled');
							} else {
								jQuery('li:first', an[i]).removeClass('disabled');
							}

							if ( oPaging.iPage === oPaging.iTotalPages-1 || oPaging.iTotalPages === 0 ) {
								jQuery('li:last', an[i]).addClass('disabled');
							} else {
								jQuery('li:last', an[i]).removeClass('disabled');
							}
						}
					}
				}
			} );
			
			/*
			 * TableTools Bootstrap compatibility
			 * Required TableTools 2.1+
			 */
			if ( jQuery.fn.DataTable.TableTools ) {
				// Set the classes that TableTools uses to something suitable for Bootstrap
				jQuery.extend( true, jQuery.fn.DataTable.TableTools.classes, {
					"container": "DTTT btn-group",
					"buttons": {
						"normal": "btn",
						"disabled": "disabled"
					},
					"collection": {
						"container": "DTTT_dropdown dropdown-menu",
						"buttons": {
							"normal": "",
							"disabled": "disabled"
						}
					},
					"print": {
						"info": "DTTT_print_info modal"
					},
					"select": {
						"row": "active"
					}
				} );

				// Have the collection use a bootstrap compatible dropdown
				jQuery.extend( true, jQuery.fn.DataTable.TableTools.DEFAULTS.oTags, {
					"collection": {
						"container": "ul",
						"button": "li",
						"liner": "a"
					}
				} );
			}
		},
		
		
		dataTable: function(tableID, elementosPorPagina, data){
			var datatable = jQuery(tableID).dataTable(jQuery.extend(true, {
				"iDisplayLength": elementosPorPagina,
				"aLengthMenu": [[10, 20, 50], [10, 20, 50]]
			} ,data));
			
			if(data && data.bFilter === true){
				jQuery(".dataTables_filter input").attr("maxlength", 20);
			}

			return datatable
		}
	}
}()
